import { AppContainer } from 'react-hot-loader';
import React from 'react';
import ThickboxLoader from './util/thickbox-loader';

//make sure hot module reloading is working
if (module.hot) {
	module.hot.accept();
}


//load the thickboxes
new ThickboxLoader();



// WEBPACK FOOTER //
// ./src/index.js